import { memo } from "react";
import { Link, useNavigate } from "react-router-dom";

const bg = require("../../assets/images/screen-1-bg-1.png");
const logo = require("../../assets/images/logo.png");

const NotFound = () => {
   const navigate = useNavigate();

   return (
      <main className="nfPg" role="main">
         <div className="nfBg" aria-hidden="true">
            <img src={bg} alt="" />
         </div>

         <div className="nfCon">
            <div className="nfLogo">
               <img src={logo} alt="Quantara logo" />
            </div>

            <h1 className="nfCode" aria-label="404">
               <span>404</span>
            </h1>

            <h2 className="nfTl">Page not found</h2>
            <p className="nfTx">
               The link may be broken, or the page has moved. Go back to where you were or return to the home page.
            </p>

            <div className="nfAcs">
               <Link to="/" className="nfBtn nfBtnPrimary">
                  <span>Back to home</span>
               </Link>
               <button type="button" className="nfBtn nfBtnGhost" onClick={() => navigate(-1)}>
                  <span>Go back</span>
               </button>
            </div>
         </div>
      </main>
   );
};

export default memo(NotFound);